import HttpClient from '../utility/http-client';

export default {
    cartList(page: number, rowPerPage: number, q: any) {
        const url = `/api/cart/?page=${page}&rowsPerPage=${rowPerPage}&q=${q}`;
        return HttpClient.instance().get(url);
    },

    cartByIds(ids: string) {
        const url = `/api/cart/?ids=${ids}`;
        return HttpClient.instance().get(url);
    },

    cartEdit(dataRequest: any, cartId: number) {
        const url = `/api/cart/${cartId}`;
        return HttpClient.instance().post(url, dataRequest);
    },

    cartRemoveItem(itemId: number) {
        const url = `/api/cart_detail/${itemId}`;
        return HttpClient.instance().delete(url);
    },

    cartRemoveProducts(itemIds: number[]) {
        const url = `/api/cart_detail/`;
        return HttpClient.instance().post(url, { 'ids': itemIds });
    },

    cartRemoveCarts(itemIds: number[]) {
        const url = `/api/cart/`;
        return HttpClient.instance().post(url, { 'ids': itemIds });
    },

    cartRemove(cartId: number) {
        const url = `/api/cart/${cartId}`;
        return HttpClient.instance().delete(url);
    },

    finishCart(dataRequest: any) {
        const url = `/api/main_order/`;
        return HttpClient.instance().put(url, dataRequest);
    },
};
